import "@fortawesome/fontawesome-free"
import "@fortawesome/fontawesome-free/js/all"
import "./fontawesome/exparang"
FontAwesome.config.mutateApproach = 'sync'
